import React from "react";
import { useTranslation } from "react-i18next";
import { ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import {
    StyledButton,
    StyledIconButton,
    StyledModal,
    CrossIcon,
} from "@aureskonnect/react-ui";
import PageTitle from "@components/Common/PageTitle";

import "./styles.css";

type ListTransactionsReportingModalType = {
    isModalOpened: boolean;
    setIsModalOpened: Function;
    data: any;
};

type TransactionRow = {
    id: number;
    date: string;
    typeconecs: string;
    typetransaction: string;
    montant: string;
};

export function TransactionsReportingModal({
    isModalOpened,
    setIsModalOpened,
    data,
}: ListTransactionsReportingModalType) {
    const { t } = useTranslation();
    const [rows, setRows] = React.useState<TransactionRow[]>([]);

    const [currentPage, setCurrentPage] = React.useState(0);
    const pageSize = 10;
    const totalPages = Math.ceil(rows.length / pageSize);
    const customHeader = "custom-header";
    const columns: GridColDef[] = [
        {
            field: "date",
            headerName: "Date",
            flex: 1,
            headerClassName: customHeader,
            minWidth: 150,
        },
        {
            field: "Libellé",
            headerName: "Libellé",
            flex: 2,
            headerClassName: customHeader,
            minWidth: 150,
        },
        {
            field: "montant",
            headerName: "Montant",
            flex: 1,
            headerClassName: customHeader,
            minWidth: 150,
        },
    ];

    const handlePageChange = (newPage: number) => {
        if (newPage >= 0 && newPage < totalPages) {
            setCurrentPage(newPage);
        }
    };

    async function getTransactions() {
        try {
            // ! reste devise
            return data.flatMap((item: any, index: any) => [
                {
                    id: `${index}-franchise`,
                    date: item.date,
                    Libellé: "Total Frais Franchise",
                    montant: `${(
                        Number(item.totalFraisFixeFranchise) +
                        Number(item.totalFraisVaiableFranchise)
                    ).toFixed(2)} ${item.currency}`,
                },
                {
                    id: `${index}-softavera`,
                    date: item.date,
                    Libellé: "Total Frais Softavera",
                    montant: `${(
                        Number(item.totalFraisFixeSoftavera) +
                        Number(item.totalFraisVaiableSoftavera)
                    ).toFixed(2)} ${item.currency}`,
                },
            ]);
        } catch (error) {
            return [];
        }
    }

    React.useEffect(() => {
        const loadRows = async () => {
            const fetchedRows = await getTransactions();

            setRows(fetchedRows);
        };
        loadRows();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isModalOpened]);

    return (
        <div>
            <PageTitle title="Transactions conecs SoftaveraPay" />
            <StyledModal
                className="transactions-modal-style"
                isOpen={isModalOpened}
            >
                <ModalHeader className="d-flex align-items-center">
                    <div
                        className="d-flex align-items-center justify-content-between"
                        style={{ height: "35px", gap: "1260px" }}
                    >
                        <span className="title-modal-style__clz">
                            {t("TRANSACTIONS")}
                        </span>
                        <StyledIconButton
                            icon="CrossIcon"
                            onClick={() => setIsModalOpened(false)}
                        >
                            <CrossIcon
                                cursor="pointer"
                                height={10}
                                width={10}
                            />
                        </StyledIconButton>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <fieldset
                        className="p-3 title-legend-style"
                        style={{ width: "100%", height: "615px" }}
                    >
                        <div style={{ height: "590px", width: "100%" }}>
                            <DataGrid
                                rows={rows.slice(
                                    currentPage * pageSize,
                                    (currentPage + 1) * pageSize
                                )}
                                columns={columns}
                                disableSelectionOnClick
                               
                            />
                        </div>
                    </fieldset>
                </ModalBody>
                <ModalFooter className="d-flex justify-content-end">
                    <StyledButton
                        className="cmn_btn_cancel"
                        variant="light"
                        outline
                        size="sm"
                        onClick={() => setIsModalOpened(false)}
                    >
                        {t("Close")}
                    </StyledButton>
                </ModalFooter>
            </StyledModal>
        </div>
    );
}
